import * as React from "react";

export interface EoiFormState {
  email?: string;
  firstName?: string;
  gender?: number;
  lastName?: string;
  location?: string;
  phone?: string;
  qualification?: string;
  yearOfBirth?: number;
}

const EoiFormStateContext = React.createContext<EoiFormState | undefined>(
  undefined
);

const EoiFormDispatchContext = React.createContext<
  React.Dispatch<React.SetStateAction<EoiFormState>> | undefined
>(undefined);

interface EoiFormProviderProps {
  initialState: null | EoiFormState;
}

export const EoiFormProvider: React.FC<EoiFormProviderProps> = ({
  initialState,
  children,
}) => {
  const [state, setState] = React.useState(() => initialState);

  return (
    <EoiFormStateContext.Provider value={state}>
      <EoiFormDispatchContext.Provider value={setState}>
        {children}
      </EoiFormDispatchContext.Provider>
    </EoiFormStateContext.Provider>
  );
};

export const useEoiFormState = () => {
  const ctx = React.useContext(EoiFormStateContext);

  if (!ctx) {
    throw Error("useEoiFormState used outside EoiFormProvider");
  }

  return ctx;
};

export const useEoiFormDispatch = () => {
  const ctx = React.useContext(EoiFormDispatchContext);

  if (!ctx) {
    throw Error("useEoiFormDispatch used outside EoiFormProvider");
  }

  return ctx;
};

export const useEoiForm = () => {
  const state = useEoiFormState();
  const setState = useEoiFormDispatch();

  return [state, setState] as const;
};
